const LIST = '/sales/orders/list'
const BEFORE = '/sales/orders/before'
const CREATE = '/sales/orders/create'
const INFO_ONE_ORDERS = '/sales/orders/oneOrder'
const SEARCH_CLIENTS = '/sales/clients/searchclients'
const SEARCH_PRODUCT = '/sales/orders/searchproduct'
const ADD_PRODUCT = '/sales/orders/createproduct'
const DELETE_PRODUCT = '/sales/orders/deleteproduct'
const DELETE_ORDER = '/sales/orders'
const UPDATE = 'sales/orders/edit'
const ADD_RECEIPT_DETAIL = '/sales/orders/addreceipt'
const DELETE_RECEIPT_ITEM = '/sales/orders/receiptItem'
//const CREATE_FACTURA = "/sales/orders/createcae"
const CREATE_FACTURA = '/sales/orders/generatefe'
const CREATE_RECEIPT = '/sales/orders/createreceipt'
const DELETE_RECEIPT = '/sales/orders/receipt'
const EDIT_PRODUCT_ITEM = '/sales/orders/editproduct'
const EDIT_RECEIPT_ITEM = '/sales/orders/editreceipt'
const REMITO = '/sales/orders/genereteremito'
const PRESUPUESTO = '/sales/orders/printpresupuesto'
const COMPROBANTE = '/sales/orders/printcomprobante'
const GARANTIA = '/sales/orders/printgarantia'
const CLONAR = '/sales/orders/clonar'
const DEBIT_NOTE = '/sales/orders/createdebitnote'
const CREDIT_NOTE = '/sales/orders/createcreditnote'
const CREATE_PAYMENT_ORDER = '/sales/payment-orders/create'
const ADD_PAYMENT_ORDER_DETAIL = '/sales/orders/addPaymentOrder'
const DELETE_PAYMENT_ORDER = '/sales/orders/PaymentOrder'
const DELETE_PAYMENT_ORDER_ITEM = '/sales/orders/PaymentOrderItem'
const EDIT_PAYMENT_ORDER_ITEM = '/sales/orders/editPaymentOrder'
const SEARCH_ARCA = '/getClienteInfo.php'
const EXPORT = '/sales/orders/export'
const LISTPRODUCTSTOCK = '/sales/orders/listDeletedProducts'
const PRINT_RECEIPT = '/sales/orders/printrecibo'
const PRINT_SHIPPING = '/sales/orders/printenvio'

export const salesOrdersEndpoints = {
  LIST,
  BEFORE,
  CREATE,
  INFO_ONE_ORDERS,
  SEARCH_CLIENTS,
  SEARCH_PRODUCT,
  ADD_PRODUCT,
  DELETE_PRODUCT,
  DELETE_ORDER,
  UPDATE,
  ADD_RECEIPT_DETAIL,
  DELETE_RECEIPT_ITEM,
  CREATE_FACTURA,
  CREATE_RECEIPT,
  DELETE_RECEIPT,
  EDIT_PRODUCT_ITEM,
  EDIT_RECEIPT_ITEM,
  REMITO,
  PRESUPUESTO,
  COMPROBANTE,
  GARANTIA,
  CLONAR,
  DEBIT_NOTE,
  CREDIT_NOTE,
  CREATE_PAYMENT_ORDER,
  ADD_PAYMENT_ORDER_DETAIL,
  DELETE_PAYMENT_ORDER,
  DELETE_PAYMENT_ORDER_ITEM,
  EDIT_PAYMENT_ORDER_ITEM,
  SEARCH_ARCA,
  EXPORT,
  LISTPRODUCTSTOCK,
  PRINT_RECEIPT,
  PRINT_SHIPPING,
}
